import { render, staticRenderFns } from "./TasksProject.vue?vue&type=template&id=15cb63e7"
import script from "./TasksProject.vue?vue&type=script&lang=js"
export * from "./TasksProject.vue?vue&type=script&lang=js"
import style0 from "./TasksProject.vue?vue&type=style&index=0&id=15cb63e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports